module.exports = __webpack_public_path__ + "img/logo.d1fb5326.svg";